import { useMediaQuery } from "@mui/material";

const useIsMobile = () => {
  const IsMobileMedia = useMediaQuery("(max-width:700px)");
  return IsMobileMedia;
};

export default useIsMobile;
